import { FC } from 'react';
import { Else, If, Then, When } from 'react-if';
import { format } from 'date-fns';
import Link from 'next/link';
import { useAuth } from '@zep/auth';
import { getResizedImage } from '@zep/utils';
import { StoreCardProps } from '../../../../types/StoreTypes';
import { ZemColorIcon } from '../../../icons';
import S from './StoreAssetCard.module.scss';
const StoreAssetCard: FC<StoreCardProps> = ({
  item
}: StoreCardProps) => {
  const {
    user
  } = useAuth();
  if (!item) {
    return <></>;
  }
  const createdAt = new Date(item?.createdAt);
  createdAt.setMinutes(createdAt.getMinutes() - createdAt.getTimezoneOffset());
  return <Link className={S.card_wrapper} href={`/store/details?id=${item.hashId}`} prefetch={false} data-sentry-element="Link" data-sentry-component="StoreAssetCard" data-sentry-source-file="StoreAssetCard.tsx">
      <div className={S.card_thumbnail_wrapper}>
        <img className={S.item_img_thumbnail} src={getResizedImage(item?.finalImageUrl, 380)} alt={item?.name} loading={'lazy'} />
      </div>
      <div className={S.store_text}>
        <span className={S.item_sub_text}>{item?.player?.finalMarketName}</span>
        <span className={S.divider}>{'|'}</span>
        <span className={S.item_sub_text}>
          {format(createdAt, 'yyyy.MM.dd')}
        </span>
        <div className={S.item_title}>{item?.name}</div>
        <When condition={!user?.isEdu} data-sentry-element="When" data-sentry-source-file="StoreAssetCard.tsx">
          <div className={S.item_price}>
            <If condition={item?.price === 0} data-sentry-element="If" data-sentry-source-file="StoreAssetCard.tsx">
              <Then data-sentry-element="Then" data-sentry-source-file="StoreAssetCard.tsx">
                <>FREE</>
              </Then>
              <Else data-sentry-element="Else" data-sentry-source-file="StoreAssetCard.tsx">
                <ZemColorIcon width={18} height={18} data-sentry-element="ZemColorIcon" data-sentry-source-file="StoreAssetCard.tsx" />
                <span className={S.item_price_amount}>
                  {item?.price?.toLocaleString()}
                </span>
              </Else>
            </If>
          </div>
        </When>
      </div>
    </Link>;
};
export default StoreAssetCard;